module.exports = __webpack_public_path__ + "img/first_point.e2d609f5.png";